module.exports = __webpack_public_path__ + "img/HPCY2.98ccc33f.jpg";